import { render } from "./BroneeringuTabel.vue?vue&type=template&id=052fb5ff&scoped=true&ts=true"
import script from "./BroneeringuTabel.vue?vue&type=script&lang=ts"
export * from "./BroneeringuTabel.vue?vue&type=script&lang=ts"

import "./BroneeringuTabel.vue?vue&type=style&index=0&id=052fb5ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052fb5ff"]])

export default __exports__